
import React, { Fragment, useState } from 'react'

import { Slider } from '../Hamburger'
import ApplicationMobileMenu from '../Menus/ApplicationMobileMenu'
import { useThemeContext, setEnableClosedSidebar } from '../../contexts/ThemeProvider'

const HeaderLogo = () =>
{
	const [active, setActive] = useState(false)
	const [controller, dispatch] = useThemeContext()
	const { enableClosedSidebar } = controller
	
	const toggleEnableClosedSidebar = () =>
	{
		setEnableClosedSidebar(dispatch, !enableClosedSidebar)
	}
	
	return (
		<Fragment>
			<div className="app-header__logo">
				<div className="logo-src" />
				<div className="header__pane ms-auto">
					<div onClick={ toggleEnableClosedSidebar }>
						<Slider
							width={26}
							lineHeight={2}
							lineSpacing={5}
							color="#6c757d"
							active={ active }
							onClick={() => setActive(!active) }
						/>
					</div>
				</div>
			</div>
			<ApplicationMobileMenu />
		</Fragment>
	)
}

export default HeaderLogo
